import { Component, OnInit } from '@angular/core';
import { LoaderService } from './_services/loader.service';
import { SessionTimeoutService } from './_services/sessionTimeout.service';
import {  Http } from '@angular/http';


declare let require: any;
const lottie: any = require('assets/spinner/lottie_svg.min.js');
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
	showLoader: boolean = true;
  options: any;

  constructor(private loaderService: LoaderService,private http: Http,private sessionTimeoutService:SessionTimeoutService) { 
    
  }

  ngOnInit() {
    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val;
      if (!val) {
        lottie.stop();
      }
      else{
        lottie.play();
      }
    });

    this.sessionTimeoutService.setIdleTime(1800000); //  30 minute timeout
    this.sessionTimeoutService.handleInactivity()
      .subscribe(inactive => {
       this.sessionTimeoutService.logoutSession();
      });
    this.options = {
      container: document.getElementById('loader'),
      renderer: 'svg',
      loop: true,
      path: 'assets/spinner/spinner.json',
    }
    lottie.loadAnimation(this.options);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts